import BillingService from '@/services/accounting.services/billing.service';
import { httpClient } from "@/services";
import { billingHeader } from "@/constants/defaultHeader";

export default {
	state: {
		billingData: [],
		ppwFilesList: [],
		billingFilters: {},
		billingSettingsDefault: null,
		billingSettings: null,
		billingHeaders: [],
	},

	mutations: {
		updateBillingSettingsAll(state, payload) {
			state.billingSettings = state.billingSettings.map(item => {
				item.settings = payload;
				return item;
			});
		},
		updateBillingSettingsReset(state) {
			state.billingSettings = state.billingSettingsDefault.map(item => ({ ...item }));
		},
		SET_BILLING_DATA(state, payload) {
			const { loads, filters, settings } = payload;

			loads.map((bill) => {
				// bill.bol == 1 ? bill.bol = "true" : bill.bol = "false"
				bill.invoice == 1 ? bill.invoice = "Exist" : bill.invoice = "Not exist";
				bill.ppw_url ? bill.ppw_link = "PPW exist" : bill.ppw_link = "PPW not exist";
			});

			state.billingData = loads;
			state.billingFilters = filters;

			if (settings && settings.length > 0) {
				state.billingSettingsDefault = settings;
				state.billingSettings = settings.map(item => ({ ...item }));
				state.billingHeaders = [];
				settings.map(item => {
					if (item.settings) {
						state.billingHeaders.push(item);
					}
				});
			} else {
				state.billingSettingsDefault = billingHeader;
				state.billingSettings = billingHeader.map(item => ({ ...item }));
				state.billingHeaders = [];
				billingHeader.map(item => {
					if (item.settings) {
						state.billingHeaders.push(item);
					}
				});
			}
		},
		SET_PPW_FILES_LIST(state, payload) {
			state.ppwFilesList = payload.load_files;
		}
	},
	actions: {
		async onBillingSettingsSave({ dispatch, state }) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post('/billings/settings', { settings: state.billingSettings });
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		onBillingSettingsAll({ commit }, payload) {
			commit('updateBillingSettingsAll', payload);
		},
		onBillingSettingsReset({ commit }) {
			commit('updateBillingSettingsReset');
		},
		async sendPpwFileBiling({ dispatch }, values) {
			dispatch("actionPreloader", true);
			const { id, value } = values;
			try {
				const { data } = await httpClient.post(`loads/sendPPW/${ id }`, value);
				dispatch("actionPreloader", false);
				dispatch("setAlert", {
					type: "success",
					message: "Sended Successfully",
				});
				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async getListOfBillings({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await BillingService.getList();
				commit('SET_BILLING_DATA', data);
				dispatch("actionPreloader", false);
			} catch (error) {
				console.error(error);
			}
		},
		async getListOfPpwFiles({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await BillingService.getPPWFilesList(payload);
				commit('SET_PPW_FILES_LIST', data);
				dispatch("actionPreloader", false);
			} catch (error) {
				console.error(error);
			}
		},
		async updateFilters({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await BillingService.getBillingsFilter(payload);
				commit('SET_BILLING_DATA', data);
				dispatch("actionPreloader", false);
			} catch (error) {
				console.error(error);
			}
		},
	},
	getters: {
		updateBillingData: s => s.billingData,
		updateBillingFilters: s => s.billingFilters,
		ppwFilesList: s => s.ppwFilesList,
		billingSettingsDefault: s => s.billingSettingsDefault,
		billingSettings: s => s.billingSettings,
		billingHeaders: s => s.billingHeaders,
	},
};
